import { httpTransport } from '@/shared/api/http/httpTransport';
import type { CockpitTransport } from '@/shared/api/transport';

/** The service is the cockpit's only data source.
 *
 * Screens and hooks depend on the transport interface rather than HTTP details,
 * while the implementation always crosses the generated-contract boundary.
 */
export const transport: CockpitTransport = httpTransport;

export type { CockpitTransport } from '@/shared/api/transport';
